import { render, staticRenderFns } from "./CopyrightApplication.vue?vue&type=template&id=5d19e361&scoped=true&"
import script from "./CopyrightApplication.vue?vue&type=script&lang=js&"
export * from "./CopyrightApplication.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightApplication.vue?vue&type=style&index=0&id=5d19e361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19e361",
  null
  
)

export default component.exports